package co.maytes.standupbot.dashboard.components.widgets

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.components.motion.pressable
import co.maytes.standupbot.dashboard.styles.ControlClass
import co.maytes.standupbot.dashboard.styles.FontWeight
import co.maytes.standupbot.dashboard.styles.Space
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.onMouseDown
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Button as ButtonElement

@Composable
fun DayOfWeekPicker(
    selected: Set<Int>,
    onChange: (Set<Int>) -> Unit,
    modifier: Modifier = Modifier,
    size: ControlSize = ControlSize.Lg,
    disabled: Boolean = false,
    invalid: Boolean = false,
    ariaLabel: String = "Days of the week",
) {
    val metrics = size.metrics
    Div(
        attrs = Modifier
            .styleModifier {
                property("display", "flex")
                property("flex-wrap", "wrap")
                property("gap", "${Space.s1}")
            }
            .then(modifier)
            .toAttrs {
                attr("role", "group")
                attr("aria-label", ariaLabel)
            },
    ) {
        DAYS.forEach { day ->
            val active = selected.contains(day.index)
            ButtonElement(
                attrs = Modifier
                    .classNames(ControlClass.DAY_PILL)
                    .height(metrics.height)
                    .fontSize(metrics.fontSize)
                    .fontWeight(if (active) FontWeight.semibold else FontWeight.medium)
                    .styleModifier {
                        property("min-width", "${metrics.height}")
                        property("padding", "0 ${Space.s2}")
                    }
                    .let { if (disabled) it else it.pressable() }
                    .onClick { if (!disabled) onChange(if (active) selected - day.index else selected + day.index) }
                    .onMouseDown { event -> if (disabled) event.preventDefault() }
                    .toAttrs {
                        attr("type", "button")
                        attr("aria-pressed", active.toString())
                        attr("aria-label", day.name)
                        if (disabled) attr("aria-disabled", "true")
                        if (invalid) attr("aria-invalid", "true")
                    },
            ) {
                Text(day.short)
            }
        }
    }
}

private class Day(val index: Int, val short: String, val name: String)

private val DAYS = listOf(
    Day(1, "Mon", "Monday"),
    Day(2, "Tue", "Tuesday"),
    Day(3, "Wed", "Wednesday"),
    Day(4, "Thu", "Thursday"),
    Day(5, "Fri", "Friday"),
    Day(6, "Sat", "Saturday"),
    Day(7, "Sun", "Sunday"),
)
